module.exports = __webpack_public_path__ + "img/from-scratch-icon.dfe8aaea.svg";